/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { EnumEntriesLetterPlaceholder, FillAndStoreLetterBody, FillAndStoreLetterParams } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const fillAndStoreLetter = (
  fillAndStoreLetterBody: BodyType<FillAndStoreLetterBody>,
  params: FillAndStoreLetterParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append('file', fillAndStoreLetterBody.file);

  return request<void>(
    {
      url: `/api/letters`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
      signal,
    },
    options,
  );
};

export const getFillAndStoreLetterMutationOptions = <
  TData = Awaited<ReturnType<typeof fillAndStoreLetter>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { data: BodyType<FillAndStoreLetterBody>; params: FillAndStoreLetterParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['fillAndStoreLetter'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fillAndStoreLetter>>,
    { data: BodyType<FillAndStoreLetterBody>; params: FillAndStoreLetterParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return fillAndStoreLetter(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<FillAndStoreLetterBody>; params: FillAndStoreLetterParams },
    TContext
  >;
};

export type FillAndStoreLetterMutationResult = NonNullable<Awaited<ReturnType<typeof fillAndStoreLetter>>>;
export type FillAndStoreLetterMutationBody = BodyType<FillAndStoreLetterBody>;
export type FillAndStoreLetterMutationError = ErrorType<unknown>;

export const useFillAndStoreLetter = <
  TData = Awaited<ReturnType<typeof fillAndStoreLetter>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { data: BodyType<FillAndStoreLetterBody>; params: FillAndStoreLetterParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<
  TData,
  TError,
  { data: BodyType<FillAndStoreLetterBody>; params: FillAndStoreLetterParams },
  TContext
> => {
  const mutationOptions = getFillAndStoreLetterMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getLetterPlaceholders = (options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<EnumEntriesLetterPlaceholder>({ url: `/api/letters/placeholders`, method: 'GET', signal }, options);
};

export const getGetLetterPlaceholdersQueryKey = () => {
  return [`/api/letters/placeholders`] as const;
};

export const getGetLetterPlaceholdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLetterPlaceholdersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLetterPlaceholders>>> = ({ signal }) =>
    getLetterPlaceholders(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLetterPlaceholders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLetterPlaceholdersQueryResult = NonNullable<Awaited<ReturnType<typeof getLetterPlaceholders>>>;
export type GetLetterPlaceholdersQueryError = ErrorType<unknown>;

export function useGetLetterPlaceholders<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof request>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLetterPlaceholders<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLetterPlaceholders<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLetterPlaceholders<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLetterPlaceholdersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLetterPlaceholdersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLetterPlaceholdersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLetterPlaceholders>>> = ({ signal }) =>
    getLetterPlaceholders(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getLetterPlaceholders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLetterPlaceholdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLetterPlaceholders>>>;
export type GetLetterPlaceholdersSuspenseQueryError = ErrorType<unknown>;

export function useGetLetterPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLetterPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLetterPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLetterPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof getLetterPlaceholders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLetterPlaceholders>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLetterPlaceholdersSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
